import * as _ from "lodash";

export class AssignmentFilter {
    public users: any[] = [];
    public teams: any[] = [];
    public dateRange: any = {};
    public status: string[] = [];

    public numAppliedFilters: number = 0;
    constructor(data?: object) {
        this.setData(data);
    }

    setData(data: any): void {
        _.merge(this, data);
        this.users = data && data.users ? data.users : [];
        this.teams = data && data.teams ? data.teams : [];
        this.status = data && data.status ? data.status : [];
        this.dateRange = data && data.dateRange ? data.dateRange : {};

        if (this.dateRange) {
            if (
                this.dateRange.dateStart &&
                typeof this.dateRange.dateStart == "string"
            ) {
                this.dateRange.dateStart = new Date(this.dateRange.dateStart);
            }

            if (
                this.dateRange.dateEnd &&
                typeof this.dateRange.dateEnd == "string"
            ) {
                this.dateRange.dateEnd = new Date(this.dateRange.dateEnd);
            }
        }
        this.setNumAppliedFilters();
    }

    reset(): void {
        this.dateRange = null;
        this.status = [];
        this.users = [];
        this.teams = [];
    }

    getCustomDateTemplates(overdue: boolean = false): any {
        let than3Day = new Date();
        let than7Day = new Date();
        let than30Day = new Date();
        let than90Day = new Date();
        let than5Year = new Date();

        if (overdue) {
            return [
                {
                    name: "Last 3 Days",
                    dateStart: new Date(
                        than3Day.setDate(than3Day.getDate() - 2)
                    ),
                    dateEnd: new Date(),
                },
                {
                    name: "Last 7 Days",
                    dateStart: new Date(
                        than7Day.setDate(than7Day.getDate() - 6)
                    ),
                    dateEnd: new Date(),
                },
                {
                    name: "Last 30 Days",
                    dateStart: new Date(
                        than30Day.setDate(than30Day.getDate() - 29)
                    ),
                    dateEnd: new Date(),
                },
                {
                    name: "Last 90 Days",
                    dateStart: new Date(
                        than90Day.setDate(than90Day.getDate() - 89)
                    ),
                    dateEnd: new Date(),
                },
                {
                    name: "All Time",
                    dateStart: new Date(
                        than5Year.setDate(than90Day.getDate() - 1825)
                    ),
                    dateEnd: new Date(),
                },
            ];
        } else {
            return [
                {
                    name: "Next 3 Days",
                    dateStart: new Date(),
                    dateEnd: new Date(than3Day.setDate(than3Day.getDate() + 2)),
                },
                {
                    name: "Next 7 Days",
                    dateStart: new Date(),
                    dateEnd: new Date(than7Day.setDate(than7Day.getDate() + 6)),
                },
                {
                    name: "Next 30 Days",
                    dateStart: new Date(),
                    dateEnd: new Date(
                        than30Day.setDate(than30Day.getDate() + 29)
                    ),
                },
                {
                    name: "Next 90 Days",
                    dateStart: new Date(),
                    dateEnd: new Date(
                        than90Day.setDate(than90Day.getDate() + 89)
                    ),
                },
                {
                    name: "All Time",
                    dateStart: new Date(),
                    dateEnd: new Date(
                        than5Year.setDate(than90Day.getDate() + 1825)
                    ),
                },
            ];
        }
    }

    setNumAppliedFilters(): void {
        let num = 0;
        if (this.status.length > 0) {
            num++;
        }
        if (this.teams.length > 0 || this.users.length > 0) {
            num++;
        }
        if (this.dateRange.dateStart) {
            num++;
        }
        this.numAppliedFilters = num;
    }

    nonEmptyValues(): object {
        return {
            teams: this.teams ?? [],
            users: this.users ?? [],
            dateRange: this.dateRange,
            status: this.status ?? [],
        };
    }
}
